/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserTokenUserNestedUserRoles
 */
export interface UserTokenUserNestedUserRoles {
    /**
     * 
     * @type {string}
     * @memberof UserTokenUserNestedUserRoles
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof UserTokenUserNestedUserRoles
     */
    readonly deleted?: number;
    /**
     * 
     * @type {string}
     * @memberof UserTokenUserNestedUserRoles
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTokenUserNestedUserRoles
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof UserTokenUserNestedUserRoles
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UserTokenUserNestedUserRoles
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof UserTokenUserNestedUserRoles
     */
    client?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTokenUserNestedUserRoles
     */
    userRights: Array<string>;
}

export function UserTokenUserNestedUserRolesFromJSON(json: any): UserTokenUserNestedUserRoles {
    return UserTokenUserNestedUserRolesFromJSONTyped(json, false);
}

export function UserTokenUserNestedUserRolesFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTokenUserNestedUserRoles {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'label': json['label'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'client': !exists(json, 'client') ? undefined : json['client'],
        'userRights': json['user_rights'],
    };
}

export function UserTokenUserNestedUserRolesToJSON(value?: UserTokenUserNestedUserRoles | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'label': value.label,
        'description': value.description,
        'client': value.client,
        'user_rights': value.userRights,
    };
}


